<template>
  <div class="bonusRecord-page">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: '/home/entries/BurnCoinBonus' }">
        返回
      </el-breadcrumb-item>
      <el-breadcrumb-item> 燃烧币种分红纪录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      <div class="page-actions">
        <el-button type="success" class="btn" @click="addFirstStep()"
          >新增分红纪录</el-button
        >

        <el-date-picker
          v-model="startTime"
          type="datetime"
          :editable="false"
          value-format="timestamp"
          placeholder="开始时间"
        >
        </el-date-picker>
        <el-date-picker
          v-model="endTime"
          type="datetime"
          :editable="false"
          value-format="timestamp"
          placeholder="结束时间"
        >
        </el-date-picker>
        <el-button type="primary" class="btn" @click="search()">查询</el-button>
      </div>
      <el-table :data="pairBounsRecordInfo.records">
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column class-name="setCenter" label="目标币种">
          <el-table-column label="目标币种" prop="targetCoin"></el-table-column>
          <el-table-column
            label="分红总量	"
            prop="targetCoinBounsAmount"
          ></el-table-column>
          <el-table-column
            label="发放比列"
            prop="targetCoinGrantRate"
          ></el-table-column>
          <el-table-column label="状态" prop="targetCoinGrantRate">
            <template slot-scope="scope">
              <span v-if="scope.row.targetCoinStatus === 0">创建</span>
              <span v-else-if="scope.row.targetCoinStatus === 1">计算</span>
              <span v-else-if="scope.row.targetCoinStatus === 2"
                >部分分红发放</span
              >
              <span v-else-if="scope.row.targetCoinStatus === 3"
                >全部分红发放</span
              >
              <span v-else>发放分红失败</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="交易币种" class-name="setCenter">
          <template slot-scope="scope">
            <span>交易币种{{ scope.row.tradeCoin }}</span>
          </template>

          <el-table-column label="交易币种" prop="tradeCoin">
            <template slot-scope="scope">
              <span>{{ scope.row.tradeCoin }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="分红总量"
            prop="tradeCoinBounsAmount"
          ></el-table-column>
          <el-table-column
            label="持仓总量	"
            prop="tradePositionTotalAmount"
          ></el-table-column>

          <el-table-column
            label="发放比列"
            prop="tradeCoinGrantRate"
          ></el-table-column>

          <el-table-column label="状态" prop="targetCoinGrantRate">
            <template slot-scope="scope">
              <span v-if="scope.row.tradeCoinStatus === 0">创建</span>
              <span v-else-if="scope.row.tradeCoinStatus === 1">计算</span>
              <span v-else-if="scope.row.tradeCoinStatus === 2"
                >部分分红发放</span
              >
              <span v-else-if="scope.row.tradeCoinStatus === 3"
                >全部分红发放</span
              >
              <span v-else>发放分红失败</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="查询分红纪录">
          <template slot-scope="scope">
            <el-button type="text" @click="calculateShowDialog(scope.row)"
              >计算</el-button
            >
            <el-button type="text" @click="showDetail(scope.row)"
              >分红详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleCurrentChange"
          :current-page="pairBounsRecordInfo.page"
          :page-size="pairBounsRecordInfo.size"
          :total="pairBounsRecordInfo.total"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div>
    </el-card>
    <detail-box
      ref="detail"
      @close="closeDialog"
      @edit="refreshList"
    ></detail-box>
    <AddBox ref="add" @close="closeAddBoxDialog" @edit="refreshList"></AddBox>

    <el-dialog
      title="请选择要计算的币种"
      :visible.sync="calculateDialog"
      width="30%"
      :before-close="handleClose"
    >
      <el-select v-model="chooseCoin" placeholder="请选择币种">
        <el-option
          v-for="item in selectOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="calculate()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="请选择结束时间"
      :visible.sync="firstStepDialog"
      width="30%"
      :before-close="handleClose2"
    >
      <el-date-picker
        v-model="firstStepTime"
        type="datetime"
        :editable="false"
        value-format="timestamp"
        placeholder="结束时间"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="firstStepDialog = false">取 消</el-button>
        <el-button type="primary" @click="firstStepOK()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import '../store';
import Pagination from 'components/pagination';
import DetailBox from './DetailBox';
import AddBox from './AddBox';
import { mapActions, mapState } from 'vuex';
export default {
  components: {
    Pagination,
    DetailBox,
    AddBox
  },
  data() {
    return {
      size: 2,
      page: 1,
      selectOptions: [],
      chooseCoin: '',
      calculateDialog: false,
      currentRow: {},
      endTime: '',
      startTime: '',
      firstStepDialog: false,
      firstStepTime: ''
    };
  },
  computed: {
    ...mapState('burnCoinBonus', [
      'pairBounsRecordInfo',
      'searchPairBounslInfo'
    ])
  },
  methods: {
    ...mapActions('burnCoinBonus', [
      'getPairBounsRecordList',
      'pairBounsCalculat',
      'getSearchPairBouns'
    ]),
    showDetail(row) {
      this.$refs['detail'].setInfo(row);
      this.$refs['detail'].setVisible(true);
    },
    handleClose2() {
      this.firstStepDialog = false;
    },
    showAdd() {},
    returnPage() {
      window.history.forward();
    },
    addFirstStep() {
      this.firstStepTime = '';
      this.firstStepDialog = true;
    },
    search() {
      this.page = 1;
      this.refreshList();
    },
    firstStepOK() {
      this.getSearchPairBouns({
        endTime: this.firstStepTime,
        pairBounsConfigId: this.$route.query.id,
        startTime: this.$route.query.lastBounsTime
      }).then(res => {
        if (!res.code) {
          this.firstStepDialog = false;
          this.$refs['add'].setVisible(true);
          this.$refs['add'].setCurrentInfo(res.data);
        }
      });
    },
    closeAddBoxDialog() {},
    refreshList() {
      this.getPairBounsRecordList({
        page: this.page,
        size: this.size,
        pairBounsConfigId: this.$route.query.id,
        endTime: this.endTime,
        startTime: this.startTime
      });
    },
    handleCurrentChange(e) {
      this.page = e;
      this.refreshList();
    },
    closeDialog() {
      this.editInfo = {};
      this.dialogShow = false;
    },
    calculateShowDialog(row) {
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.calculateDialog = true;
      let selectArr = [];
      selectArr.push({ value: row.tradeCoin, label: row.tradeCoin });
      selectArr.push({ value: row.targetCoin, label: row.targetCoin });
      this.selectOptions = selectArr;
    },
    handleClose() {
      this.selectOptions = [];
      this.chooseCoin = '';
      this.currentRow = {};
      this.calculateDialog = false;
    },
    calculate() {
      this.pairBounsCalculat({
        coinType: this.chooseCoin,
        id: this.currentRow.id
      }).then(res => {
        if (!res.code) {
          this.refreshList();
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          });
          this.calculateDialog = false;
        }
      });
    }
  },
  mounted() {
    this.refreshList();
  }
};
</script>
<style lang="less">
.bonusRecord-page {
  .el-table {
    .cell {
      text-align: center !important;
    }
    .setCenter {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .pagination-box {
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
